import { property, subclass } from '@arcgis/core/core/accessorSupport/decorators';
import { whenDefinedOnce } from '@arcgis/core/core/watchUtils';

import { messageBundle, storeNode, tsx } from '@arcgis/core/widgets/support/widget';

import Widget from '@arcgis/core/widgets/Widget';
import { VNode } from 'src/interfaces/interfaces';


export interface AlertWrapperProperties extends __esri.WidgetProperties {
  title: string;
  msg: string;
  type: "success" | "error";
  goToLinkId?: string;
}

const ALERT_DISMISS_TIME = 7500;

@subclass('Landing.widgets.AlertWrapper')
export default class AlertWrapper extends Widget {
  @property()
  title: string;

  @property()
  msg: string;

  @property()
  type: "success" | "error";

  @property()
  goToLinkId?: string;

  @property()
  alertNotificationDOM: HTMLCalciteAlertElement;

  @property({ readOnly: true })
  isDestroyed: boolean = false;
  
  private _alertLinkDOM: HTMLCalciteLinkElement;

  constructor(properties?: AlertWrapperProperties) {
    super(properties);
  }

  postInitialize() {
    whenDefinedOnce(this, "alertNotificationDOM", (alertDOM: HTMLCalciteAlertElement)=>{
      setTimeout(()=>{
        alertDOM.active = false;
        this._set("isDestroyed", true);
      }, ALERT_DISMISS_TIME);
    });
  }

  render() {
    return (
      <calcite-alert
        afterCreate={storeNode}
        bind={this}
        data-node-ref="alertNotificationDOM"
        active={true}
        scale="m"
        color={this.type === "success" ? "green" : "red"}
      >
        <div
          slot="title"
          afterCreate={storeNode}
          bind={this}
          data-node-ref="_alertTitleDOM"
        >
          {this.title}
        </div>
        <div
          slot="message"
          afterCreate={storeNode}
          bind={this}
          data-node-ref="_alertMsgDOM"
        >
          {this.msg}
        </div>
        {/* 
        TODO: implement Go To Link
        <calcite-link
          slot="link"
          title={goTo}
          afterCreate={storeNode}
          bind={this}
          data-node-ref="alertLinkDOM"
          onclick={(e) => {
            // go to proper page
            console.log("LINK CLICK", e);
          }}
        > {goTo}
        </calcite-link> */}
      </calcite-alert>
    )
  }



}
